// ═══════════════════════════════════════════════════════════════
// Handoff — Module Layout with sub-navigation
// ═══════════════════════════════════════════════════════════════

import { Outlet, useLocation } from 'react-router-dom';
import {
  IconLayoutDashboard, IconCalendarEvent, IconArrowsExchange,
  IconChecklist, IconTemplate, IconUsers, IconChartBar,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import type { NavItem } from '../../types/nav';
import { brand } from '../../lib/colors';
import PageHeader from '../../components/ui/PageHeader';
import ModuleNav from '../../components/layout/ModuleNav';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/handoff', icon: IconLayoutDashboard, exact: true },
  { label: 'Events', path: '/handoff/events', icon: IconCalendarEvent },
  { label: 'Handoffs', path: '/handoff/notes', icon: IconArrowsExchange },
  { label: 'Shift Assignments', path: '/handoff/staff', icon: IconUsers },
  { label: 'Actions', path: '/handoff/actions', icon: IconChecklist },
  { label: 'Analytics', path: '/handoff/analytics', icon: IconChartBar },
  { label: 'Templates', path: '/handoff/templates', icon: IconTemplate, minLevel: 'editor' },
];

export default function HandoffLayout() {
  const { pathname } = useLocation();
  const visibleItems = useFilteredNav('handoff', NAV_ITEMS);

  const isDetail = pathname.match(/\/handoff\/event\/\d/) || pathname.match(/\/handoff\/note\//);

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      {!isDetail && (
        <>
          <PageHeader
            breadcrumbs={[
              { label: 'Respond' },
              { label: 'Shift Handoff' },
            ]}
            title="Shift Handoff"
            subtitle="Manage shift briefings, handoff notes & position tracking"
          />
          <ModuleNav items={visibleItems} accentColor={brand.blurple} />
        </>
      )}
      <Outlet />
    </div>
  );
}
